import {
  Action_GetListChiNhanh,
  Action_GetListChiNhanhSuccess,
} from "./actionTypes";

export const Index_GetListChiNhanh = (data) => ({
  type: Action_GetListChiNhanh,
  payload: data
});
export const Index_GetListChiNhanhSuccess = (data) => ({
  type: Action_GetListChiNhanhSuccess,
  payload: data,
});
